<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add Video
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small @click="closePanel" color="primary">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.title"
              v-model="video.title"
              label="Video Title"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter video title</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-textarea
              v-model="video.description"
              label="Description"
              hint="Enter a description for this video"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter a description for this video</span>
              </v-tooltip>
            </template>  
            </v-textarea>
            <drop-zone
              :type="type"
              :accepted="accepted"
              :maxFilesize="maxUploadSize"
              class="mt-5 dropzone-container"
            ></drop-zone>
            <label v-if="messages.file"
            :error-messages="messages.file" class="v-messages theme--light error--text">{{ messages.file[0] }}</label>
            <template>
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on" class="dropzone-help">fa fa-question</v-icon>
               </template>
               <span>Click here to upload a file</span>
              </v-tooltip>
            </template>
            <p class="block text-left mt-4 caption">
              Max upload filesize: {{maxUploadSize}}MB <br />
              Accepted file formats: MP4
            </p>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex text-right>
        <v-btn v-if="!s3Uploading || !loading" :color="$store.getters.partner ? 'primary': 'grey300'"  @click="closePanel"
          >Cancel</v-btn
        >&nbsp;
        <v-btn v-if="s3Uploading || loading" color="primary" class="ml-2" loading></v-btn>
        <v-btn v-else :color="$store.getters.partner ? 'primary': 'dark-blue'" :class="['ml-2', $store.getters.partner ? '' : 'add-course-button']"  @click="addAsset"
          >Add Video</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import courseAPI from "@/api/course.js";
import DropZone from "@/components/global/Dropzone";

export default {
  name: "AddVideo",
  components: {
    DropZone
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    video: {},
    messages: {},
    type: "video",
    accepted: "video/mp4",
    loading: false,
    successMessage: "External Training Successfully Added.",
    errorMessage:
      "Oops, something went wrong! Please check information is correct.",
    uploadingMessage: "Please wait while video uploads.",
  }),
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    maxUploadSize() {
      let id = this.$store.getters.user.id;
      switch (id) {
        case '8ykwxd4gxr3ampj9':
          return 300
        case '8qd4gynlmj9xmwvj': // Default Company
          return 900
        case '843jgy0mgn970qve': // Safe Guarding Courses Company
          return 900
        default:
          return 250
      }

        // return (this.$store.getters.user.id=='8ykwxd4gxr3ampj9' ? 300 : 150);
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.video.courseId = this.id;
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addAsset() {
      this.loading = true;
      courseAPI
        .addVideo(
          this.video,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(resp => {
          this.$store.dispatch("addCourseMaterials", resp.data.data);
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
